import { useTranslations } from '@vocab/react';
import { Inline, Text, TextLink } from 'braid-design-system';
import React from 'react';

import translations from 'src/locales.vocab';
import { wwwUrl } from 'src/modules/location';

export const Footer = () => {
  const { t } = useTranslations(translations);
  return (
    <Inline space="medium">
      <Text size="small">
        <TextLink href={wwwUrl('/privacy/')} rel="noreferrer" target="_blank">
          {t('Privacy')}
        </TextLink>
      </Text>

      <Text size="small">
        <TextLink href={wwwUrl('/terms/')} rel="noreferrer" target="_blank">
          {t('Terms & Conditions')}
        </TextLink>
      </Text>
    </Inline>
  );
};
